import { Country } from "./Country.js";
import { SubscriptionSize } from "./SubscriptionSize.js";
import { isCountryInEuropeanUnion } from "./utils/isCountryInEuropeanUnion.js";

const euSubscriptionPackageSurchargeCzkSizeMap: Record<SubscriptionSize, number> = {
	[SubscriptionSize.G250]: 120,
	[SubscriptionSize.G250x2]: 0,
	[SubscriptionSize.Kg1]: 0,
};

/**
 * Returns the flat per-delivery EU surcharge without tax in CZK for the given destination country
 * and subscription size.
 */
export function getSubscriptionEuSurchargeCzk(
	destinationCountry: Country | "outsideEu",
	size: SubscriptionSize,
): number {
	if (destinationCountry === Country.Czechia || !isCountryInEuropeanUnion(destinationCountry)) {
		return 0;
	}
	return euSubscriptionPackageSurchargeCzkSizeMap[size];
}
